import { post, get, put, deleteApi } from '../axiosFun';
/* 我的培训任务 */
// 分页
const trainPlanMyPage = data => {
  return post('/train/plan/myPage', data)
};
/* 我的课程 */
// 分页
const trainCourseMyPage = data => {
  return post('/train/course/myCoursePage', data)
};
// 详情
const trainCourseDetail = courseId => {
  return get('/train/course/detail/' + courseId)
};
export default {
  trainPlanMyPage,
  trainCourseMyPage,
  trainCourseDetail
}




// WEBPACK FOOTER //
// ./src/api/participationTrain/index.js